/* eslint-disable */

import axios from 'axios';
import router from '../route';

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    addCourse: false,
    editCourse: {},
    courseDetailstab: false,
    addCourseData: {},
    createCourseSection: {},
    getcourseDetailstabByID: {},
    updatedcourseDetailstabByID: {},
    getCourseSection: {},
    editCourseSection: {},
    removeCourseSection: {},
    createCourseSectionFile: {},
    getCourseSectionFile: {},
    editCourseSectionFile: {},
    courseCategory: {},
    sectionByCourseID: {},
    removeSectionByCourse: {},
    bulletsList: {},
    removeCourseTabs: {},
    deletebulletsList: {},
    getbulletsList: {},
    editbulletsList: {},
    updateBulletPointIndex: {},
    updateTabIndex: {},
    createtopicdata: {},
    gettopicdata: {},
    updatetopicdata: {},
    gettopicsdata: {}

  },
  mutations: {
    SET_COURSE(state, value) {
      state.addCourse = value;
      state.addCourseData = value
    },
    EDIT_COURSE(state, value) {
      state.editCourse = value;
    },
    SECTIONBYCOURSEID(state, value) {
      state.sectionByCourseID = value;
    },
    COURSETABDETAILS(state, value) {
      state.courseTabDetails = value;
    },
    REMOVESECTIONBYCOURS(state, value) {
      state.removeSectionByCourse = value;
    },
    COURSE_DETAILS_TAB(state, value) {
      state.courseDetailstab = value;
    },
    REMOVE_COURSE_TAB(state, value) {
      state.removeCourseTabs = value
    },
    GET_COURSE_TAB_DETAILS_BY_ID(state, value) {
      state.getcourseDetailstabByID = value;
    },
    UPDATE_COURSE_TAB_DETAILS_BY_ID(state, value) {
      state.updatedcourseDetailstabByID = value
    },
    CREATE_COURSE_SECTION(state, value) {
      state.createCourseSection = value;
    },
    GET_COURSE_SECTION(state, value) {
      state.getCourseSection = value;
      // debugger
    },
    EDIT_COURSE_SECTION(state, value) {
      state.editCourseSection = value;
      // debugger
    },
    REMOVE_COURSE_SECTION(state, value) {
      state.removeCourseSection = value;
    },
    CREATE_COURSE_SECTION_FILE(state, value) {
      state.createCourseSectionFile = value;
    },
    GET_COURSE_SECTION_FILE(state, value) {
      state.getCourseSectionFile = value;
    },
    EDIT_COURSE_SECTION_FILE(state, value) {
      state.editCourseSectionFile = value;
    },
    SET_COURSE_CATEGORY(state, value) {
      state.courseCategory = value
    },
    CREATE_BULLETS_POINT(state, value) {
      state.bulletsList = value
    },
    DELETE_BULLETS_POINT(state, value) {
      state.deletebulletsList = value
    },
    GET_BULLETS_POINT(state, value) {
      state.getbulletsList = value
    },
    EDIT_BULLETS_POINT(state, value) {
      state.editbulletsList = value
    },
    UPDATE_BULLET_POINT_INDEX(state, value) {
      state.updateBulletPointIndex = value
    },
    UPDATE_TAB_INDEX(state, value) {
      state.updateTabIndex = value
    },
    CREATE_TOPIC(state, value) {
      state.createtopicdata = value
    },
    Get_Topic_Data(state, value) {
      state.gettopicdata = value
    },
    UPDATE_TOPIC(state, value) {
      state.updatetopicdata = value
    },
    GET_TOPICS(state, value) {
      state.gettopicsdata = value
    }
  },
  actions: {
    create_course(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/course/', payload).then((response) => {
            context.commit('SET_COURSE', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    sectionbycourseId(context, payload) {
      let url = baseURL + "courses/admin/course/";
        if(payload.tab_name){
          return new Promise((resolve, reject) => {
          axios.get(url + payload.id + '/' + '?tab=' + payload.tab_name).then((response) => {
              context.commit('SECTIONBYCOURSEID', response.data);
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
          })
          }else{
            return new Promise((resolve, reject) => {
            axios.get(url + payload.id).then((response) => {
                context.commit('SECTIONBYCOURSEID', response.data);
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              })
            })
          }
    },
    edit_course(context, payload) {
      let url = baseURL + "courses/admin/course/";
      let id = payload.data.id;
      console.log(payload.data.id)
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.data).then((response) => {
            context.commit('EDIT_COURSE', response.data);
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    RemoveSectionByCourseFun(context, payload) {
      let url = baseURL + "courses/admin/course/section/file/";
      return new Promise((resolve, reject) => {
        axios.delete(url + payload.id + '/').then((response) => {
            if (response.status != '401' && response.status != '403') {
              context.commit('REMOVESECTIONBYCOURS', response.data);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    course_details_tab(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/course/detail-tab/', payload).then((response) => {
            context.commit('COURSE_DETAILS_TAB', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getCourseTabDetailsByID(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + "courses/admin/course/detail-tab/";
        axios.get(url + payload.id + '/').then((response) => {
            context.commit('GET_COURSE_TAB_DETAILS_BY_ID', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateCourseTabDetailsByID(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + "courses/admin/course/detail-tab/";
        let id = payload.data.id;
        axios.patch(url + id + '/', payload.data.data).then((response) => {
            context.commit('UPDATE_COURSE_TAB_DETAILS_BY_ID', response);
            console.log(response.data)
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    course_section_create(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/course/section/', payload).then((response) => {
            console.log(response.data);
            // debugger;
            context.commit('CREATE_COURSE_SECTION', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    get_course_section_fun(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + "courses/admin/course/section/";
        axios.get(url + payload.id + '/').then((response) => {
            context.commit('GET_COURSE_SECTION', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    edit_course_section_fun(context, payload) {
      let url = baseURL + "courses/admin/course/section/";
      let id = payload.data.id;
      console.log(id)
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.data).then((response) => {
            console.log(response.data);
            context.commit('EDIT_COURSE_SECTION', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    remove_course_section_fun(context, payload) {
      let url = baseURL + "courses/admin/course/section/";
      return new Promise((resolve, reject) => {
        axios.delete(url + payload.id + '/').then((response) => {
            context.commit('REMOVE_COURSE_SECTION', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // Remove Course Tab By ID
    RemoveCourseTabByID(context, payload) {
      let url = baseURL + "courses/admin/course/detail-tab/";
      return new Promise((resolve, reject) => {
        axios.delete(url + payload.id + '/').then((response) => {
            context.commit('REMOVE_COURSE_TAB', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // Create Course Section File Data
    course_section_file_create(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/course/section/file/', payload).then((response) => {
            console.log(response.data);
            // debugger;
            context.commit('CREATE_COURSE_SECTION_FILE', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    get_course_section_files_id(context, payload) {
      let url = baseURL + "courses/admin/course/section/file/";
      return new Promise((resolve, reject) => {
        axios.get(url + payload.id + '/').then((response) => {
            console.log(response.data);
            context.commit('GET_COURSE_SECTION_FILE', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    edit_course_section_files_id(context, payload) {
      let url = baseURL + "courses/admin/course/section/file/";
      let id = payload.data.id;
      console.log(payload.data.formdata, 'tetvsajhvjhvd jbjsbj')
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.formdata, {
            headers: {
              'Content-Type': null
            }
          }).then((response) => {
            console.log(response.data);
            context.commit('EDIT_COURSE_SECTION_FILE', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateStsOfSectionFileById(context, payload) {
      let url = baseURL + "courses/admin/course/section/file/";
      let id = payload.data.id;
      // debugger
      console.log(payload.data.formdata, 'updated dAta')
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.formdata, {
            headers: {
              'Content-Type': null
            }
          }).then((response) => {
            console.log(response.data);
            context.commit('EDIT_COURSE_SECTION_FILE', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getCourseCategory(context) {
      return new Promise((resolve, reject) => {
        axios.get("courses/admin/category/").then(function(response) {
            context.commit('SET_COURSE_CATEGORY', response.data);
            resolve(response);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    create_bullets_list(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post("courses/admin/course/detail-tab/list/", payload).then(function(response) {
          context.commit('CREATE_BULLETS_POINT', response.data);
          resolve(response);
        }).catch(
          function(err) {
            reject(err);
          }
        )
      })
    },
    remove_bullets_list(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("courses/admin/course/detail-tab/list/" + payload.id + '/').then(function(response) {
          context.commit('DELETE_BULLETS_POINT', response.data);
          resolve(response);
        }).catch(
          function(err) {
            reject(err);
          }
        )
      })
    },
    GetBulletdataByID(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get("courses/admin/course/detail-tab/list/" + payload.id + '/').then(function(response) {
          context.commit('GET_BULLETS_POINT', response.data);
          resolve(response);
        }).catch(
          function(err) {
            reject(err);
          }
        )
      })
    },
    UpdateBulletPointById(context, payload) {
      let url = baseURL + "courses/admin/course/detail-tab/list/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/', payload.data.data).then((response) => {
            console.log(response.data);
            context.commit('EDIT_BULLETS_POINT', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateBulletPointIndex(context, payload) {
      let id = payload.data.id;
      let url = baseURL + "courses/admin/course/detail-tab/list/" + id + "/index/";
      return new Promise((resolve, reject) => {
        axios.patch(url, payload.data.data).then((response) => {
            context.commit('UPDATE_BULLET_POINT_INDEX', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateTabIndex(context, payload) {
      let id = payload.data.id;
      let url = baseURL + "courses/admin/course/detail-tab/" + id + "/index/";
      return new Promise((resolve, reject) => {
        axios.patch(url, payload.data.data).then((response) => {
            context.commit('UPDATE_TAB_INDEX', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // Create Course Topic
    create_topic(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/course/section/topic/', payload).then((response) => {
            console.log(response.data);
            context.commit('CREATE_TOPIC', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    create_topic(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('courses/admin/course/section/topic/', payload).then((response) => {
            console.log(response.data);
            context.commit('CREATE_TOPIC', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    get_topics(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('courses/admin/course/section/topic/' + payload.id + '/').then((response) => {
            context.commit('GET_TOPICS', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    update_topic(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('courses/admin/course/section/topic/' + payload.data.id + '/', payload.data.formdata).then((response) => {
            console.log(response.data);
            context.commit('UPDATE_TOPIC', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    delete_topic(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('courses/admin/course/section/topic/' + payload.id + '/').then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateTopicByIndex(context, payload) {
      let id = payload.data.id;
      let url = baseURL + "courses/admin/course/section/topic/" + id + "/index/";
      return new Promise((resolve, reject) => {
        axios.patch(url, payload.data.data).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    }
  },
  getters: {
    getSetCourse: state => state.addCourse,
    getCourseDetailsTab: state => state.courseDetailstab,
    getcourseDetailstabByIDState: state => state.getcourseDetailstabByID,
    getaddCourseData: state => state.addCourseData,
    getcourseCategoryState: state => state.courseCategory,
    getsectionbycourseIDState: state => state.sectionByCourseID,
    getremoveSectionbycourseState: state => state.removeSectionByCourse,
    getsectionFilesState: state => state.getCourseSectionFile,
    geteditSectionFilesState: state => state.editCourseSectionFile,
    getcourseSectionByIDDataState: state => state.getCourseSection,
    getBulletDataByIDState: state => state.getbulletsList,
    createtopicdataState: state => state.createtopicdata,
    gettopicdataState: state => state.gettopicdata,
    updatetopicdataState: state => state.updatetopicdata,
    gettopicsdataState: state => state.gettopicsdata
  }
}